import { WpViewTable } from '../../core';

export function determinePeriod(table: WpViewTable): {
    start: Date;
    end: Date;
    createdOn: Date;
} {
    const row =
        table.rows?.[0]?.row?.individual ?? table.rows?.[0]?.row?.peopleDetail;
    return {
        start: row?.startDateDataRange,
        end: row?.endDateDataRange,
        createdOn: row?.createdOn,
    };
}
